import { OrganizationsState } from "./organizations"

export default {
  all(state: OrganizationsState) {
    return state.organizations
  },
  loading(state: OrganizationsState) {
    return state.loading
  },
  loadingAppIds(state: OrganizationsState) {
    return state.loadingAppIds
  },
  loadingClientIds(state: OrganizationsState) {
    return state.loadingClientIds
  },
  loadingUsers(state: OrganizationsState) {
    return state.loadingUsers
  },
  selectedOrganization(state: OrganizationsState) {
    return state.selectedOrganization
  },
  orgAppIds(state: OrganizationsState) {
    return state.orgAppIds
  },
  orgClientIds(state: OrganizationsState) {
    return state.orgClientIds
  },
  orgUsers(state: OrganizationsState) {
    return state.orgUsers
  },
}
